import { IStudentLogDetailRequest, IStudentLogItemRequest } from "../../../models/request/y-te/studentLogRequests";
import { IStudentLogSelectRequest } from "../../../models/request/y-te/yTeRequests";
import { StudentLogItemResponse } from "../../../models/response/y-te/studentlog";
import {
	eStudentLogActionTypeIds,
	IStudentLogChangeSelectedIds,
	IStudentLogCloseConfirm,
	IStudentLogCloseDetail,
	IStudentLogDeleteErr,
	IStudentLogDeleteStart,
	IStudentLogDeleteSuccess,
	IStudentLogLoadDetailErr,
	IStudentLogLoadDetailStart,
	IStudentLogLoadDetailSuccess,
	IStudentLogLoadErr,
	IStudentLogLoadStart,
	IStudentLogLoadSuccess,
	IStudentLogSaveErr,
	IStudentLogSaveStart,
	IStudentLogSaveSuccess,
	IStudentLogShowConfirm,
	IStudentLogShowDetail
} from "../../action-types/y-te/IStudentLogActionTypes";

export const studentLogActions = {
	loadStudentLogStart: (request: IStudentLogSelectRequest): IStudentLogLoadStart => {
		return {
			type: eStudentLogActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadStudentLogSuccess: (data: StudentLogItemResponse[]): IStudentLogLoadSuccess => {
		return {
			type: eStudentLogActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadStudentLogError: (message: string): IStudentLogLoadErr => {
		return {
			type: eStudentLogActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadStudentLogDetailStart: (request: IStudentLogDetailRequest): IStudentLogLoadDetailStart => {
		return {
			type: eStudentLogActionTypeIds.LOAD_DETAIL_START,
			payload: request
		}
	},
	loadStudentLogDetailSuccess: (data: StudentLogItemResponse): IStudentLogLoadDetailSuccess => {
		return {
			type: eStudentLogActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadStudentLogDetailError: (message: string): IStudentLogLoadDetailErr => {
		return {
			type: eStudentLogActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showStudentLogDetail: (data?: StudentLogItemResponse): IStudentLogShowDetail => {
		return {
			type: eStudentLogActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeStudentLogDetail: (): IStudentLogCloseDetail => {
		return {
			type: eStudentLogActionTypeIds.CLOSE_DETAIL
		}
	},
	changeStudentLogSelectedIds: (ids: number[]): IStudentLogChangeSelectedIds => {
		return {
			type: eStudentLogActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showStudentLogConfirm: (): IStudentLogShowConfirm => {
		return {
			type: eStudentLogActionTypeIds.SHOW_CONFIRM
		}
	},
	closeStudentLogConfirm: (): IStudentLogCloseConfirm => {
		return {
			type: eStudentLogActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveStudentLogStart: (data: IStudentLogItemRequest): IStudentLogSaveStart => {
		return {
			type: eStudentLogActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveStudentLogSuccess: (is_update: boolean): IStudentLogSaveSuccess => {
		return {
			type: eStudentLogActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveStudentLogError: (message: string): IStudentLogSaveErr => {
		return {
			type: eStudentLogActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteStudentLogStart: (id: number): IStudentLogDeleteStart => {
		return {
			type: eStudentLogActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteStudentLogSuccess: (): IStudentLogDeleteSuccess => {
		return {
			type: eStudentLogActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteStudentLogError: (message: string): IStudentLogDeleteErr => {
		return {
			type: eStudentLogActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
